import { FC, PropsWithChildren } from "react";
import s from "./EnergyFootprint.module.css";

const EnergyFootprint = ({ children }) => {
  return (
    <div className="container mt-8 xl:mt-0 ">
      <h2 className="text-blue-dark lg:text-5xl text-4xl font-bold  lg:my-9 my-7">
        Umwelt
      </h2>
      <div className="flex lg:flex-row flex-col">{children}</div>
    </div>
  );
};

const Table: FC<PropsWithChildren<{ label: string }>> = ({
  children,
  label,
}) => {
  return (
    <div className="lg:w-1/2 w-full  lg:border-r-[1px] border-gray-300 ">
      <table
        className={`table-auto lg:w-[75%] w-full ${s.EnergyFootprintTable}`}
      >
        <thead>
          <tr className="border-b-0">
            {children && (
              <th className="text-blue-dark lg:text-4xl text-3xl text-left">
                {label}
              </th>
            )}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};

const TableRow: FC<PropsWithChildren<{ label: string; value: string }>> = ({
  label,
  value,
}) => {
  return (
    <tr className="">
      <td dangerouslySetInnerHTML={{ __html: label }} />
      <td>{value || "-"}</td>
    </tr>
  );
};

const Chart = ({ energyClass }) => {
  const isActive = (identifier: string, energyClass: string) => {
    if (identifier === energyClass) return "";
    else return "hidden";
  };
  return (
    <div className="lg:w-1/2 w-full flex justify-center flex-col xl:pl-[15%] lg:pl-[5%] ">
      <h2 className="text-3xl xl:text-4xl text-blue-dark lg:py-0 py-8  lg:mb-7">
        CO2 Effizienzklasse***
      </h2>

      <div className="flex relative 2xl:w-1/2 lg:w-[70%] ">
        <svg id="Ebene_3" viewBox="0 45 241 216" width="100%" height="100%">
          <polygon
            fill="#53B04B"
            className={`cls-6`}
            points="9.46 50.78 8.35 54.16 10.62 54.16 9.53 50.78 9.46 50.78"
          />
          <path
            fill="#53B04B"
            className={` cls-6`}
            d="m63.32,43.87H0v18.66h63.32l8.28-9.33-8.28-9.33Zm-51.55,13.81l-.66-2.04h-3.23l-.66,2.04h-2.03l3.09-8.95h2.44l3.08,8.95h-2.03Zm9.6-2.8h-2.31v2.31h-1.56v-2.31h-2.31v-1.56h2.31v-2.31h1.56v2.31h2.31v1.56Z"
          />
          <polygon
            fill="#BFD238"
            className={` cls-2`}
            points="9.46 72.7 8.35 76.09 10.62 76.09 9.53 72.7 9.46 72.7"
          />
          <path
            fill="#BFD238"
            className={` cls-2`}
            d="m76.52,65.8H0v18.66h76.52l8.28-9.33-8.28-9.33Zm-64.75,13.81l-.66-2.04h-3.23l-.66,2.04h-2.03l3.09-8.95h2.44l3.08,8.95h-2.03Z"
          />
          <path
            fill="#BFD238"
            className={` cls-2`}
            d="m9.65,96.19c.2-.09.36-.22.48-.39.12-.17.18-.37.18-.61,0-.32-.11-.58-.34-.78-.23-.2-.55-.3-.97-.3h-1.44v2.21h1.4c.26,0,.49-.05.69-.14Z"
          />
          <path
            fill="#BFD238"
            className={` cls-2`}
            d="m9.93,97.77c-.22-.11-.48-.16-.78-.16h-1.59v2.38h1.54c.53,0,.91-.1,1.15-.3.24-.2.36-.47.36-.81,0-.25-.06-.47-.18-.66-.12-.19-.29-.34-.51-.44Z"
          />
          <path
            fill="#BFD238"
            className={` cls-2`}
            d="m87.24,87.72H0v18.66h87.24l8.28-9.33-8.28-9.33Zm-75.02,12.6c-.23.37-.58.66-1.04.88-.46.22-1.02.32-1.69.32h-3.82v-8.95h3.58c.66,0,1.21.1,1.65.29.44.19.77.46.99.81.22.35.33.74.33,1.19,0,.35-.07.66-.21.92-.14.26-.33.48-.57.65-.24.17-.52.29-.83.36v.09c.34.02.66.11.96.29.3.18.54.43.73.75.19.32.28.7.28,1.14,0,.48-.12.9-.35,1.27Z"
          />
          <path
            fill="#d6ea41"
            className={` cls-3`}
            d="m97.57,109.65H0v18.66h97.57l8.28-9.33-8.28-9.33ZM7.71,120.59c.19.43.46.76.8.98.34.22.74.33,1.19.33.25,0,.49-.03.71-.1.22-.07.41-.17.58-.3.17-.13.31-.29.42-.47.11-.19.19-.4.23-.64h1.91c-.05.42-.17.81-.37,1.2-.2.38-.46.72-.79,1.02-.33.3-.72.53-1.18.71-.46.17-.97.26-1.54.26-.8,0-1.51-.18-2.14-.54-.63-.36-1.12-.88-1.49-1.57-.36-.68-.54-1.51-.54-2.49s.18-1.81.55-2.49c.37-.68.86-1.21,1.49-1.57.63-.36,1.34-.54,2.12-.54.52,0,1,.07,1.44.22s.84.36,1.18.64c.34.28.62.62.84,1.02s.36.86.42,1.38h-1.91c-.04-.25-.11-.47-.21-.66-.11-.19-.25-.36-.41-.5-.17-.14-.36-.24-.58-.31-.22-.07-.46-.11-.71-.11-.46,0-.87.11-1.21.34-.34.23-.61.56-.8,1-.19.44-.28.96-.28,1.58s.1,1.17.29,1.61Z"
          />
          <path
            fill="#F7E827"
            className={` cls-1`}
            d="m10.18,138.35c-.38-.2-.85-.3-1.41-.3h-1.21v5.71h1.2c.56,0,1.03-.1,1.41-.3.38-.2.67-.51.86-.93s.29-.97.29-1.63-.1-1.2-.29-1.62c-.19-.42-.48-.73-.86-.93Z"
          />
          <path
            fill="#F7E827"
            className={` cls-1`}
            d="m109.62,131.57H0v18.66h109.62l8.28-9.33-8.28-9.33Zm-96.93,11.73c-.35.67-.85,1.18-1.51,1.54-.65.36-1.44.54-2.34.54h-3.17v-8.95h3.2c.9,0,1.68.18,2.32.53.65.36,1.15.87,1.5,1.54.35.67.53,1.47.53,2.39s-.18,1.73-.53,2.4Z"
          />
          <path
            fill="#FAB71D"
            className={` cls-4`}
            d="m120.44,153.5H0v18.66h120.44l8.28-9.33-8.28-9.33Zm-108.68,13.81h-5.92v-8.95h5.9v1.56h-4.05v2.13h3.75v1.56h-3.75v2.14h4.07v1.56Z"
          />
          <path
            fill="#ED7027"
            className={` cls-4`}
            d="m131.64,175.42H0v18.66h131.64l8.28-9.33-8.28-9.33Zm-120,6.42h-3.95v2.13h3.56v1.56h-3.56v3.7h-1.85v-8.95h5.8v1.56Z"
          />
          <path
            fill="#E52529"
            className={` cls-4`}
            d="m144.38,197.34H0v18.66h144.38l8.28-9.33-8.28-9.33Zm-130.77,10.14c0,.79-.16,1.46-.49,2.02-.32.56-.77,1-1.34,1.3-.57.3-1.22.46-1.96.46-.82,0-1.54-.19-2.16-.56-.62-.37-1.11-.9-1.45-1.59s-.52-1.5-.52-2.44c0-.73.1-1.37.31-1.94s.5-1.05.87-1.45c.37-.4.81-.7,1.3-.9.5-.21,1.03-.31,1.61-.31.5,0,.96.07,1.39.22.43.15.81.36,1.14.62.33.27.6.59.81.96s.35.77.41,1.22h-1.88c-.06-.21-.14-.4-.25-.57-.11-.16-.24-.3-.4-.42-.16-.11-.33-.2-.53-.26s-.42-.09-.66-.09c-.45,0-.84.11-1.18.34-.34.23-.6.56-.79.99-.19.43-.28.96-.28,1.58s.09,1.15.28,1.59c.18.44.45.77.79,1,.34.23.74.34,1.2.34.42,0,.78-.08,1.08-.23.3-.15.53-.37.68-.65.15-.27.22-.58.23-.94h-1.87v-1.42h3.66v1.13Z"
          />

          {/* A+ */}
          <polygon
            className={`${isActive("A+", energyClass)} cls-7`}
            points="217.09 51.01 215.99 54.4 218.26 54.4 217.16 51.01 217.09 51.01"
          />
          <path
            className={`${isActive("A+", energyClass)} cls-7`}
            d="m200.78,44.11l-8.28,9.33,8.28,9.33h40.22v-18.66h-40.22Zm18.62,13.81l-.66-2.04h-3.23l-.66,2.04h-2.03l3.09-8.95h2.44l3.08,8.95h-2.03Zm9.6-2.8h-2.31v2.31h-1.56v-2.31h-2.31v-1.56h2.31v-2.31h1.56v2.31h2.31v1.56Z"
          />
          {/* A */}
          <polygon
            className={`${isActive("A", energyClass)} cls-7`}
            points="220.88 72.7 219.78 76.09 222.05 76.09 220.95 72.7 220.88 72.7"
          />
          <path
            className={`${isActive("A", energyClass)} cls-7`}
            d="m200.78,65.8l-8.28,9.33,8.28,9.33h40.22v-18.66h-40.22Zm22.41,13.81l-.66-2.04h-3.23l-.66,2.04h-2.03l3.09-8.95h2.44l3.08,8.95h-2.03Z"
          />
          {/* B */}
          <path
            className={`${isActive("B", energyClass)} cls-7`}
            d="m221.72,97.77c-.22-.11-.48-.16-.78-.16h-1.59v2.38h1.54c.53,0,.91-.1,1.15-.3.24-.2.36-.47.36-.81,0-.25-.06-.47-.18-.66-.12-.19-.29-.34-.51-.44Z"
          />
          <path
            className={`${isActive("B", energyClass)} cls-7`}
            d="m221.44,96.19c.2-.09.36-.22.48-.39.12-.17.18-.37.18-.61,0-.32-.11-.58-.34-.78-.23-.2-.55-.3-.97-.3h-1.44v2.21h1.4c.26,0,.49-.05.69-.14Z"
          />
          <path
            className={`${isActive("B", energyClass)} cls-7`}
            d="m200.78,87.72l-8.28,9.33,8.28,9.33h40.22v-18.66h-40.22Zm23.23,12.6c-.24.37-.58.66-1.04.88-.46.22-1.02.32-1.69.32h-3.82v-8.95h3.58c.66,0,1.21.1,1.65.29.44.19.77.46.99.81.22.35.33.74.33,1.19,0,.35-.07.66-.21.92-.14.26-.33.48-.57.65-.24.17-.52.29-.83.36v.09c.34.02.66.11.96.29.3.18.54.43.73.75.19.32.28.7.28,1.14,0,.48-.12.9-.35,1.27Z"
          />
          {/* C */}
          <path
            className={`${isActive("C", energyClass)} cls-7`}
            d="m200.78,109.65l-8.28,9.33,8.28,9.33h40.22v-18.66h-40.22Zm18.28,10.94c.19.43.46.76.8.98.34.22.74.33,1.19.33.25,0,.49-.03.71-.1.22-.07.41-.17.58-.3.17-.13.31-.29.42-.47.11-.19.19-.4.23-.64h1.91c-.05.42-.17.81-.37,1.2-.2.38-.46.72-.79,1.02-.33.3-.72.53-1.18.71-.46.17-.97.26-1.54.26-.8,0-1.51-.18-2.14-.54-.63-.36-1.12-.88-1.49-1.57-.36-.68-.54-1.51-.54-2.49s.18-1.81.55-2.49c.37-.68.86-1.21,1.49-1.57.63-.36,1.34-.54,2.12-.54.52,0,1,.07,1.44.22.44.15.84.36,1.18.64.34.28.62.62.84,1.02.22.4.36.86.42,1.38h-1.91c-.04-.25-.11-.47-.21-.66-.11-.19-.25-.36-.41-.5-.17-.14-.36-.24-.58-.31-.22-.07-.46-.11-.71-.11-.46,0-.87.11-1.21.34-.34.23-.61.56-.8,1-.19.44-.28.96-.28,1.58s.1,1.17.29,1.61Z"
          />
          {/* D */}
          <path
            className={`${isActive("D", energyClass)} cls-7`}
            d="m200.78,131.57l-8.28,9.33,8.28,9.33h40.22v-18.66h-40.22Zm23.43,11.73c-.35.67-.85,1.18-1.51,1.54-.65.36-1.44.54-2.34.54h-3.17v-8.95h3.2c.9,0,1.68.18,2.32.53.65.36,1.15.87,1.5,1.54.35.67.53,1.47.53,2.39s-.18,1.73-.53,2.4Z"
          />
          <path
            className={`${isActive("D", energyClass)} cls-7`}
            d="m221.7,138.35c-.38-.2-.85-.3-1.41-.3h-1.21v5.71h1.2c.56,0,1.03-.1,1.41-.3.38-.2.67-.51.86-.93s.29-.97.29-1.63-.1-1.2-.29-1.62c-.19-.42-.48-.73-.86-.93Z"
          />
          {/* E */}
          <path
            className={`${isActive("E", energyClass)} cls-7`}
            d="m200.78,153.51l-8.28,9.33,8.28,9.33h40.22v-18.66h-40.22Zm23.02,13.81h-5.92v-8.95h5.9v1.56h-4.05v2.13h3.75v1.56h-3.75v2.14h4.07v1.56Z"
          />
          {/* F */}
          <path
            className={`${isActive("F", energyClass)} cls-7`}
            d="m200.78,175.42l-8.28,9.33,8.28,9.33h40.22v-18.66h-40.22Zm23.02,6.42h-3.95v2.13h3.56v1.56h-3.56v3.7h-1.85v-8.95h5.8v1.56Z"
          />
          {/* G */}
          <path
            className={`${isActive("G", energyClass)} cls-7`}
            d="m200.78,197.34l-8.28,9.33,8.28,9.33h40.22v-18.66h-40.22Zm24.09,10.14c0,.79-.16,1.46-.49,2.02-.32.56-.77,1-1.34,1.3-.57.3-1.22.46-1.96.46-.82,0-1.54-.19-2.16-.56-.62-.37-1.11-.9-1.45-1.59-.35-.69-.52-1.5-.52-2.44,0-.73.1-1.37.31-1.94.21-.57.5-1.05.87-1.45.37-.4.81-.7,1.3-.9.5-.21,1.03-.31,1.61-.31.5,0,.96.07,1.39.22.43.15.81.36,1.14.62.33.27.6.59.81.96.21.37.35.77.41,1.22h-1.88c-.06-.21-.14-.4-.25-.57-.11-.16-.24-.3-.4-.42-.16-.11-.33-.2-.53-.26-.2-.06-.42-.09-.66-.09-.45,0-.84.11-1.18.34-.34.23-.6.56-.79.99-.19.43-.28.96-.28,1.58s.09,1.15.28,1.59c.18.44.45.77.79,1,.34.23.74.34,1.2.34.42,0,.78-.08,1.08-.23.3-.15.53-.37.68-.65.15-.27.22-.58.23-.94h-1.87v-1.42h3.66v1.13Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default Object.assign(EnergyFootprint, { Table, TableRow, Chart });
